import Immutable from 'immutable';
import * as types from '../../actions/vacancies/types';
import reducerCreator from '../../tools/reducer-creator';

import { QUESTION_PRESCREENING_TYPE, QUESTION_SUPPLEMENTARY_TYPE } from '../../constants/question-types';

const initialState = Immutable.fromJS({
  supplementary: [],
  prescreening: [],
  isPrescreeningLoading: false,
  isSupplementaryLoading: false,
  isPrescreeningQuestionAdding: false,
  isSupplementaryQuestionAdding: false,
  isPrescreeningQuestionDeleting: false,
  isSupplementaryQuestionDeleting: false
});

export default reducerCreator(initialState, {
  [types.VACANCY_SET_QUESTIONS_LOADING]: (state, { isLoading, part }) => {
    switch(part) {
      case QUESTION_PRESCREENING_TYPE: {
        return state.set('isPrescreeningLoading', isLoading);
      }
      case QUESTION_SUPPLEMENTARY_TYPE: {
        return state.set('isSupplementaryLoading', isLoading);
      }
      default: {
        return state;
      }
    }
  },

  [types.VACANCY_SET_QUESTIONS]: (state, { questions, questionsType }) => {
    switch(questionsType) {
      case QUESTION_PRESCREENING_TYPE: {
        return state.set('prescreening', Immutable.fromJS(questions));
      }
      case QUESTION_SUPPLEMENTARY_TYPE: {
        return state.set('supplementary', Immutable.fromJS(questions));
      }
      default: {
        return state;
      }
    }
  },

  [types.VACANCY_SET_QUESTION_ADDING]: (state, { isLoading, questionType }) => {
    switch(questionType) {
      case QUESTION_PRESCREENING_TYPE: {
        return state.set('isPrescreeningQuestionAdding', isLoading);
      }
      case QUESTION_SUPPLEMENTARY_TYPE: {
        return state.set('isSupplementaryQuestionAdding', isLoading);
      }
      default: {
        return state;
      }
    }
  },

  [types.VACANCY_SET_QUESTION_DELETING]: (state, { isLoading, questionType }) => {
    switch(questionType) {
      case QUESTION_PRESCREENING_TYPE: {
        return state.set('isPrescreeningQuestionDeleting', isLoading);
      }
      case QUESTION_SUPPLEMENTARY_TYPE: {
        return state.set('isSupplementaryQuestionDeleting', isLoading);
      }
      default: {
        return state;
      }
    }
  },

  [types.VACANCY_RESET_QUESTIONS]: () =>
    initialState
});



// WEBPACK FOOTER //
// ./src/reducers/vacancies/vacancy-questions.js